import { useState, useEffect } from "react";
import WidgetContainer from "../reusablesComponents/containerWidget";
import BodyResults from "./cardResults/bodyResults/bodyResults";
import FooterResults from "./cardResults/footerResults/footerResults";
import { getResults } from "../../services/getGameResults";
import "./results.sass";

export default function Results({ type, sport, idEvent }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      const result = await getResults({ type, sport, idEvent });
      if (result.statusCode === 200) {
        setData(result.data);
      } else {
        setData([]);
      }
      setLoading(false);
    }

    fetchData();
  }, [type, sport, idEvent]);

  return (
    <WidgetContainer loading={loading} heightLoading={""} className="container__game-results" id="container__game-results">
      <div className="results__component">
        <BodyResults data={data[0]} />
        <FooterResults data={data[0]} />
      </div>
    </WidgetContainer>
  )
}